var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovingIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5574_27844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9965 38.8017C32.1743 38.8017 38.8036 32.1723 38.8036 23.9946C38.8036 15.8169 32.1743 9.1875 23.9965 9.1875C15.8188 9.1875 9.18945 15.8169 9.18945 23.9946C9.18945 32.1723 15.8188 38.8017 23.9965 38.8017Z",
    fill: "#013668"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4711 6L18.4423 20.3149L22.0491 21.2782L16.558 26.5654L21.2617 27.8239L12.5293 41.9982L28.616 26.7904L24.7139 25.7498L30.2542 20.2587L26.0568 19.1337L35.4711 6Z",
    fill: "#FFB300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5574_27844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingIco);
export default __webpack_public_path__ + "static/media/movingIco.34b452b9d3b29c97534f98eeb2bacda2.svg";
export { ForwardRef as ReactComponent };